var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.60739 10.2176L10.8124 9.01253C10.8653 8.95966 10.9281 8.91772 10.9971 8.88911C11.0662 8.8605 11.1403 8.84577 11.215 8.84577C11.2898 8.84577 11.3638 8.8605 11.4329 8.88911C11.502 8.91772 11.5647 8.95966 11.6176 9.01253L14.8332 12.2282C14.94 12.3349 15 12.4798 15 12.6308C15 12.7818 14.94 12.9266 14.8332 13.0333L13.6275 14.2391C11.851 16.0156 7.53059 14.5754 3.97757 11.0224C0.424547 7.46943 -1.01558 3.14903 0.760926 1.37249L1.96666 0.166753C2.07344 0.0599828 2.21825 0 2.36925 0C2.52025 0 2.66506 0.0599828 2.77183 0.166753L5.98747 3.3824C6.04034 3.43526 6.08228 3.49803 6.11089 3.5671C6.13951 3.63618 6.15423 3.71021 6.15423 3.78498C6.15423 3.85975 6.13951 3.93378 6.11089 4.00286C6.08228 4.07193 6.04034 4.1347 5.98747 4.18756L4.78243 5.39261C4.67673 5.4983 4.59289 5.62378 4.53569 5.76188C4.47848 5.89998 4.44904 6.04799 4.44904 6.19746C4.44904 6.34694 4.47848 6.49495 4.53569 6.63305C4.59289 6.77115 4.67673 6.89663 4.78243 7.00232L7.99768 10.2176C8.21115 10.431 8.50066 10.551 8.80254 10.551C9.10442 10.551 9.39393 10.431 9.60739 10.2176Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneWhite);
export default __webpack_public_path__ + "static/media/phoneWhite.80b0595f3b4cad520f440989de0c3b42.svg";
export { ForwardRef as ReactComponent };